<template>
  <div class="announce">
    <ListTitle :title="title" :titleImg="titleImg" />
    <ListGroup :itemList="itemList" :fn="goToDetails" />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import ListGroup from "@/components/ui/searchList/ListGroup.vue";
export default {
  props: {
    title: {
      type: String,
      default: "最新消息"
    },
    titleImg: {
      type: String,
      default: "common/icon_promotion.svg"
    }
  },
  data() {
    return {
      itemList: []
    };
  },
  components: {
    Footer,
    ListTitle,
    ListGroup
  },

  methods: {
    goToDetails(item, idx) {
      this.SYS.goToDetails(
        item,
        idx,
        this.itemList,
        "Announce-Detail"
        //this.$router
      );
      // this.$router.push({
      //   name: "Announce-Detail",
      //   params: {
      //     item: item
      //     //subject: "經典樹種介紹"
      //   },
      //   query: {
      //     idx: idx
      //     //name: item.Sno
      //   }
      // });
    }
  },
  mounted() {
    this.itemList = [];
    this.itemList = this.$store.state.announce.announceList;
    if (this.itemList.length == 0) {
      this.$store.dispatch("setProcessWait", [
        this.$store.dispatch("getAnnounceList").then(() => {
          this.itemList = this.$store.state.announce.announceList;
        })
      ]);
    }
  }
};
</script>
<style lang="scss" scoped>
.announce {
  height: inherit;
  background-color: #f6edd9;
}
</style>
